import { parseTL } from "../AmountInput";
import { todayIso } from "../../lib/format";

// limit revize tarihi (kart vadesi): bugüne göre kalan gün (null = vade yok); ≤ 30 gün → yaklaşıyor, < 0 → geçti
export const LR_REVISION_DAYS = 30;
export const revDays = (r) => (r?.due_date ? Math.round((new Date(r.due_date) - new Date(todayIso())) / 86400000) : null);
export const revUrgent = (r) => { const d = revDays(r); return d != null && d <= LR_REVISION_DAYS; };
export const revLabel = (d) => (d < 0 ? `Revize tarihi geçti (${-d} gün)` : d === 0 ? "Revize bugün" : `Revize ${d} gün`);

export const LR_DEFAULT_ROWS = ["ROTATİF", "SPOT", "BCH", "KMH", "TAKSİTLİ", "KREDİ KARTI", "ÇEK KARNESİ"];
export const LR_LETTER_ROW = "TEMİNAT MEKTUBU";
export const LR_GAYRINAKDI_ROWS = ["ÇEK KARNESİ", LR_LETTER_ROW];   // bunlar dışındaki varsayılan türler nakdi kredidir
export const LR_SIDE_OPTS = [["nakdi", "Nakdi"], ["gayrinakdi", "Gayrinakdi"], ["both", "Her ikisi"]];
export const LR_COLS = [["ipotek", "İPOTEK"], ["kefalet", "KEFALET"], ["kgf", "KGF"]];
export const LR_SIDES = [["nakdi", "NAKDİ"], ["gayrinakdi", "GAYRİNAKDİ"]];
export const LR_KIND_LABEL = { limit: "LİMİT", risk: "RİSK" };

const up = (s) => String(s || "").toLocaleUpperCase("tr");
export const inferSide = (name) => (LR_GAYRINAKDI_ROWS.includes(up(name)) ? "gayrinakdi" : LR_DEFAULT_ROWS.includes(up(name)) ? "nakdi" : "both");
export const isStandardRow = (row) => !!row?.auto || LR_DEFAULT_ROWS.includes(up(row?.name));   // standart satırlar kaldırılamaz
export const rowHasSide = (row, side) => (row?.side || inferSide(row?.name)) === "both" || (row?.side || inferSide(row?.name)) === side;
export const emptyCell = () => ({ ipotek: "", kefalet: "", kgf: "" });
export const emptySide = () => ({ nakdi: emptyCell(), gayrinakdi: emptyCell() });
export const newRow = (name, auto = false, side) => ({ name, auto, side: side || inferSide(name), limit: emptySide(), risk: emptySide() });
export const defaultRows = () => [...LR_DEFAULT_ROWS.map((n) => newRow(n)), newRow(LR_LETTER_ROW, true)];
export const EMPTY_LR = { company: "", bank: "", report_date: "", due_date: "", description: "", rows: defaultRows(), mortgages: [], letters_total: 0, letters_count: 0, auto_order: ["kgf", "kefalet", "ipotek"] };
export const lrCls = "w-full px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none";
// doluluk rengi: %80+ kırmızı, %60+ amber, altı yeşil
export const usageTone = (pct) => (pct == null ? "text-slate-400" : pct >= 80 ? "text-red-700" : pct >= 60 ? "text-amber-700" : "text-emerald-700");
export const usageBar = (pct) => (pct == null ? "bg-slate-300" : pct >= 80 ? "bg-red-500" : pct >= 60 ? "bg-amber-500" : "bg-emerald-500");

export const num = (v) => (typeof v === "number" ? v : parseTL(v) ?? 0);
export const cellSum = (c) => LR_COLS.reduce((a, [k]) => a + num(c?.[k]), 0);
// satır toplamları: nakdi / gayrinakdi / genel (sütun bazında) / toplam; kapalı taraf 0 sayılır;
// risk tarafında auto_risk = {taraf: tutar} otomatik kaynaktan gelir (TEMİNAT MEKTUBU → mektuplar, kredi türü → Banka Kredileri bakiyesi), hücreler sayılmaz
export const autoSides = (row, kind) => (kind === "risk" ? row?.auto_risk || (row?.auto ? { gayrinakdi: 0 } : {}) : {});
// teminat düşüm sırası: otomatik risk sırayla sütunların LİMİT'ine kadar düşer; limiti aşan kısım son dolan sütunda kalır, hiç limit yoksa sıranın ilk sütununda
export const LR_AUTO_ORDER = ["kgf", "kefalet", "ipotek"];   // varsayılan: KGF → KEFALET → İPOTEK
const COL_LABEL = Object.fromEntries(LR_COLS);
export const normOrder = (order) => (Array.isArray(order) && order.length === 3 && LR_COLS.every(([k]) => order.includes(k)) ? order : LR_AUTO_ORDER);
export const orderLabel = (order) => normOrder(order).map((k) => COL_LABEL[k]).join(" → ");
export const LR_ORDER_OPTS = [["kgf", "kefalet", "ipotek"], ["kgf", "ipotek", "kefalet"], ["kefalet", "ipotek", "kgf"], ["kefalet", "kgf", "ipotek"], ["ipotek", "kefalet", "kgf"], ["ipotek", "kgf", "kefalet"]].map((o) => [o.join(","), orderLabel(o)]);
export const allocAuto = (row, side, amount, order) => {
  const ord = normOrder(order);
  const lim = row?.limit?.[side] || {};
  const out = Object.fromEntries(LR_COLS.map(([k]) => [k, 0]));
  let rem = Number(amount) || 0, last = null;
  for (const k of ord) {
    const cap = num(lim[k]);
    if (cap <= 0) continue;
    last = k;
    const take = Math.min(rem, cap);
    out[k] = take; rem -= take;
    if (rem <= 0) break;
  }
  if (rem > 0) out[last || ord[0]] += rem;
  return out;
};
export const autoCells = (row, kind, order) => Object.fromEntries(Object.entries(autoSides(row, kind)).map(([s, v]) => [s, allocAuto(row, s, v, order)]));
export const rowTotals = (row, kind, order) => {
  const cells = autoCells(row, kind, order);
  const n = "nakdi" in cells ? cells.nakdi : rowHasSide(row, "nakdi") ? row?.[kind]?.nakdi || {} : {};
  const g = "gayrinakdi" in cells ? cells.gayrinakdi : rowHasSide(row, "gayrinakdi") ? row?.[kind]?.gayrinakdi || {} : {};
  const nn = cellSum(n), gn = cellSum(g);
  const genel = Object.fromEntries(LR_COLS.map(([k]) => [k, num(n[k]) + num(g[k])]));
  return { nakdi: nn, gayrinakdi: gn, genel, total: nn + gn };
};
export const matrixTotals = (rows, kind, order) => (rows || []).reduce((acc, r) => {
  const t = rowTotals(r, kind, order);
  return { nakdi: acc.nakdi + t.nakdi, gayrinakdi: acc.gayrinakdi + t.gayrinakdi, total: acc.total + t.total };
}, { nakdi: 0, gayrinakdi: 0, total: 0 });
const cellToForm = (c) => Object.fromEntries(LR_COLS.map(([k]) => [k, c?.[k] ? c[k] : ""]));
const sideToForm = (s) => ({ nakdi: cellToForm(s?.nakdi), gayrinakdi: cellToForm(s?.gayrinakdi) });
export const toFormRows = (rows) => (rows || []).map((r) => ({ name: r.name, auto: !!r.auto, side: r.side || inferSide(r.name), auto_risk: r.auto_risk, auto_src: r.auto_src, auto_count: r.auto_count, limit: sideToForm(r.limit), risk: sideToForm(r.risk) }));
const cellToApi = (c) => Object.fromEntries(LR_COLS.map(([k]) => [k, num(c?.[k])]));
const sideToApi = (row, kind) => Object.fromEntries(LR_SIDES.map(([s]) => [s, rowHasSide(row, s) ? cellToApi(row[kind]?.[s]) : cellToApi(null)]));
export const toApiRows = (rows) => rows.filter((r) => String(r.name || "").trim()).map((r) => ({ name: r.name.trim(), auto: !!r.auto, side: r.side || inferSide(r.name), limit: sideToApi(r, "limit"), risk: sideToApi(r, "risk") }));

// Özet: kart toplamları (limit/risk × nakdi/gayrinakdi)
export const lrSummary = (cards) => {
  const s = { limit: 0, risk: 0, nakdiLimit: 0, nakdiRisk: 0, gayriLimit: 0, gayriRisk: 0 };
  for (const c of cards) {
    const t = c.totals || {};
    s.limit += t.limit?.total || 0; s.risk += t.risk?.total || 0;
    s.nakdiLimit += t.limit?.nakdi || 0; s.nakdiRisk += t.risk?.nakdi || 0;
    s.gayriLimit += t.limit?.gayrinakdi || 0; s.gayriRisk += t.risk?.gayrinakdi || 0;
  }
  return { ...s, remaining: s.limit - s.risk, pct: s.limit ? (s.risk / s.limit) * 100 : null, banks: cards.length };
};
